<ng-template vdrDialogTitle>Create Bulk Time Slots</ng-template>

<div class="form-grid" [formGroup]="form">
    <vdr-form-field label="Start Date">
        <input type="date" formControlName="startDate" [min]="minDate" />
    </vdr-form-field>

    <vdr-form-field label="End Date">
        <input type="date" formControlName="endDate" [min]="minDate" />
    </vdr-form-field>

    <vdr-form-field label="Start Time">
        <input type="time" formControlName="startTime" />
    </vdr-form-field>

    <vdr-form-field label="End Time">
        <input type="time" formControlName="endTime" />
    </vdr-form-field>

    <vdr-form-field label="Slot Duration (minutes)">
        <input type="number" formControlName="slotDurationInMinutes" />
    </vdr-form-field>

    <vdr-form-field label="Max Orders per Slot">
        <input type="number" formControlName="maxOrdersPerSlot" />
    </vdr-form-field>
</div>

<ng-template vdrDialogButtons>
    <button type="button" class="btn" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="create()">Create</button>
</ng-template>
